<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    // document.title = "CreditYa";
    // this.setRem();
    // window.addEventListener('resize', this.setRem);
    window.removeEventListener('touchmove', this.preventScroll);

    // console.log(process.env.NODE_ENV, 'process.env.NODE_ENV>>>>>>>>>>>>>')
  },
  methods: {
    // setRem() {
    //   const designWidth = 750;
    //   const scale = document.documentElement.clientWidth / designWidth;
    //   console.log(scale, 'scale>>>>>>')
    //   document.documentElement.style.fontSize = scale * 100 + 'px';
    // }
    preventScroll(event) {
      event.preventDefault();
    }
  }
}
</script>

<style lang="less">
body {
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
}
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, 
dl, dt, dd, ul, ol, li, 
pre,
fieldset, lengend, button, input, textarea, 
th, td {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0,0,0,0.9);
  background: #fff;
}
html{font-size:62.5%;}
body {font:normal 100% Arial,sans-serif;font-size:14px; font-size:1.4rem; } 

</style>
